'use client';

export { default } from './CardMedia';
export { default as cardMediaClasses } from './cardMediaClasses';
export * from './cardMediaClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CardMedia/index.js
// module id = 830
// module chunks = 22